import * as React from "react";
import { ChakraProvider } from "@chakra-ui/react";
import { MemoryRouter, Route, Routes } from "react-router-dom";
import moment from "moment";
import "moment/locale/de";
import "moment/locale/nl";
import "moment/locale/fr";
import "moment/locale/es";
import "moment/locale/en-gb";
import "moment/locale/fi";
import "moment/locale/da";
import "moment/locale/pl";
import { IntlProvider } from "react-intl";
import ChakraTheme from "./templates/Chakra";
import ScapsTemplate from "./templates/Scaps";

import Home from "./pages/home/Home";
import Step1 from "./pages/step1/Step1";
import Step2 from "./pages/step2/Step2";
import Step3 from "./pages/step3/Step3";
import Step4 from "./pages/step4/Step4";
import Step5 from "./pages/step5/Step5";
import Step6 from "./pages/step6/Step6";
import Step7 from "./pages/step7/Step7";
import Step8 from "./pages/step8/Step8";
import Step9 from "./pages/step9/Step9";
import Step10 from "./pages/step10/Step10";
import Step11 from "./pages/step11/Step11";
import Step12 from "./pages/step12/Step12";
import Loader from "./pages/loader/Loader";
import Complete from "./pages/complete/Complete";

function App() {
  const currentUrl = window.location.toString();

  let locale = "de";
  moment.locale("de");

  switch (true) {
    case currentUrl.search("/nl") !== -1:
      locale = "nl";
      moment.locale("nl");
      break;

    case currentUrl.search("/de") !== -1:
      locale = "de";
      moment.locale("de");
      break;

    case currentUrl.search("/dk") !== -1:
      locale = "da";
      moment.locale("da");
      break;

    case currentUrl.search("/fi") !== -1:
      locale = "fi";
      moment.locale("fi");
      break;

    case currentUrl.search("/fr") !== -1:
      locale = "fr";
      moment.locale("fr");
      break;

    case currentUrl.search("/uk") !== -1:
      locale = "en";
      moment.locale("en");
      break;
    case currentUrl.search("/pl") !== -1:
      locale = "pl";
      moment.locale("pl");
      break;

    default:
  }

  if (window.locale) {
    locale = window.locale;
    switch (locale) {
      case "nl":
        locale = "nl";
        moment.locale("nl");
        break;

      case "de":
        locale = "de";
        moment.locale("de");
        break;

      case "fi":
        locale = "fi";
        moment.locale("fi");
        break;

      case "dk":
        locale = "da";
        moment.locale("da");
        break;

      case "fr":
        locale = "fr";
        moment.locale("fr");
        break;

      case "uk":
        locale = "en";
        moment.locale("en");
        break;

      case "pl":
        locale = "pl";
        moment.locale("pl");
        break;

      default:
    }
  }

  return (
    <MemoryRouter>
      <ChakraProvider theme={ChakraTheme}>
        <IntlProvider locale={locale} defaultLocale="de">
          <ScapsTemplate>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/step1" element={<Step1 />} />
              <Route path="/step2" element={<Step2 />} />
              <Route path="/step3" element={<Step3 />} />
              <Route path="/step4" element={<Step4 />} />
              <Route path="/step5" element={<Step5 />} />
              <Route path="/step6" element={<Step6 />} />
              <Route path="/step7" element={<Step7 />} />
              <Route path="/step8" element={<Step8 />} />
              <Route path="/step9" element={<Step9 />} />
              <Route path="/step10" element={<Step10 />} />
              <Route path="/step11" element={<Step11 />} />
              <Route path="/step12" element={<Step12 />} />
              <Route path="/loader" element={<Loader />} />
              <Route path="/complete" element={<Complete />} />
            </Routes>
          </ScapsTemplate>
        </IntlProvider>
      </ChakraProvider>
    </MemoryRouter>
  );
}

export default App;
